/**
 * Shared user-facing strings for the adjustment header. Centralized so both
 * platforms read the same copy and i18n has a single seam.
 */
export const NO_CHANGE_TEXT = 'No change'
export const RESET_LABEL = 'Reset'

/**
 * The header's context line has two states. Each platform renders them with
 * its own primitives but the decision tree (and the chevron direction for
 * the changed case) lives here once.
 */
export type ContextState =
  | { kind: 'unchanged' }
  | {
      kind: 'changed'
      delta: number
      baseline: number
      direction: 'up' | 'down'
    }

export type ComputeContextStateArgs = {
  value: number
  baseline: number
}

export const computeContextState = ({
  value,
  baseline,
}: ComputeContextStateArgs): ContextState => {
  if (value === baseline) return { kind: 'unchanged' }
  const delta = value - baseline
  return {
    kind: 'changed',
    delta,
    baseline,
    direction: delta > 0 ? 'up' : 'down',
  }
}
